import React, { useState } from "react";
import { Vector3 } from "three";
import { Button as ButtonAntd, Col, InputNumber, Popover, Row, Slider, message } from "antd";
import Icon from "@ant-design/icons";
import { DataIndexItem } from "../../../types/interfaces";
import { DataIndexActionType } from "../../../common/constant";
// import { ReactComponent as AxisIconSvg } from "../../../assets/svgs/axis.svg";
import { ReactComponent as MoveIcon } from "../../../assets/svgs/icons/move-icon.svg";
import { getIdToken } from "../../userManager/userManagementUtils";
import { api_trigger_fxn } from "../../../utils/APIs/ApiUtils";

interface TranslationPanelProps {
    record: DataIndexItem;
    actionHandler: (actionType: DataIndexActionType, dataId: string, value: any) => void;
}

const TranslationPanel = ({ record, actionHandler }: TranslationPanelProps) => {
    const [translationVlaue, setTranslationVlaue] = useState(record.translationV3);

    const onReset = () => {
        setTranslationVlaue(new Vector3());

        actionHandler(DataIndexActionType.Translation, record.data_id, {
            value: 0,
            axis: "X"
        });

        actionHandler(DataIndexActionType.Translation, record.data_id, {
            value: 0,
            axis: "Y"
        });

        actionHandler(DataIndexActionType.Translation, record.data_id, {
            value: 0,
            axis: "Z"
        });
    };

    const onSave = async () => {
        const translationData = JSON.stringify({ X: translationVlaue.x, Y: translationVlaue.y, Z: translationVlaue.z });
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            message.error("Error updating data index.");
            return
        }
        const params = {
            action: "update",
            data_id: record.data_id,
            owner_id: record.owner_id,
            update_dict: { translation: translationData },
        };
        let body: { message: string };
        try {
            body = await api_trigger_fxn("data_index", params);
            message.success("Successfully updated.");
        } catch (err) {
            message.error("Error updating data index.");
        }
    };

    return (
        <Popover
            placement="bottomRight"
            content={
                <div style={{ width: 400 }}>
                    <Row>
                        <Col span={24}>
                            {["X", "Y", "Z"].map((axis) => (
                                <Row key={axis}>
                                    <Col style={{ marginTop: 10 }} span={2}>
                                        {axis}
                                    </Col>
                                    <Col span={15}>
                                        <Slider
                                            min={-2000}
                                            max={2000}
                                            step={20}
                                            marks={{
                                                "-2000": "-2000",
                                                0: "0",
                                                2000: "2000"
                                            }}
                                            defaultValue={0}
                                            value={
                                                // eslint-disable-next-line no-nested-ternary
                                                axis === "X"
                                                    ? translationVlaue.x
                                                    : axis === "Y"
                                                    ? translationVlaue.y
                                                    : translationVlaue.z
                                            }
                                            onChange={(value: number) => {
                                                const newV3 = translationVlaue.clone();
                                                if (axis === "X") {
                                                    newV3.x = value;
                                                } else if (axis === "Y") {
                                                    newV3.y = value;
                                                } else {
                                                    newV3.z = value;
                                                }
                                                setTranslationVlaue(newV3);
                                                actionHandler(DataIndexActionType.Translation, record.data_id, {
                                                    value,
                                                    axis
                                                });
                                            }}
                                        />
                                    </Col>
                                    <Col span={6} offset={1}>
                                        <InputNumber
                                            min={0}
                                            max={2000}
                                            defaultValue={0}
                                            value={
                                                // eslint-disable-next-line no-nested-ternary
                                                axis === "X"
                                                    ? translationVlaue.x
                                                    : axis === "Y"
                                                    ? translationVlaue.y
                                                    : translationVlaue.z
                                            }
                                            onChange={(value: number | null) => {
                                                const newValue = value || 0;

                                                const newV3 = translationVlaue.clone();
                                                if (axis === "X") {
                                                    newV3.x = newValue;
                                                } else if (axis === "Y") {
                                                    newV3.y = newValue;
                                                } else {
                                                    newV3.z = newValue;
                                                }
                                                setTranslationVlaue(newV3);
                                                actionHandler(DataIndexActionType.Translation, record.data_id, {
                                                    value: newValue,
                                                    axis: axis
                                                });
                                            }}
                                        />
                                    </Col>
                                </Row>
                            ))}
                        </Col>
                    </Row>
                    <Row style={{ justifyContent: "end" }}>
                        <div className="translation-buttons">
                            <ButtonAntd type="primary" onClick={onReset}>
                                Reset
                            </ButtonAntd>
                            <ButtonAntd style={{ marginLeft: 10 }} type="primary" onClick={onSave}>
                                Save
                            </ButtonAntd>
                        </div>
                    </Row>
                </div>
            }
            trigger="click"
        >
            <MoveIcon key="MoveIcon" title="Move" color='#ffffff' style={{ pointerEvents: !record.loaded  ? "none" : "auto"}} />
        </Popover>
    );
};

export default TranslationPanel;
